import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

import { ENV_CONFIG } from 'src/app/core/injection.token';
import { DEFAULT_PAGE_SIZE } from '../../constants/commonConstants';
import { AssetEvents, ServiceAppointmentEvents } from './events';
import { ServiceAppointment } from 'src/app/features/my-assets/asset-service-appointment/utils/models';

type DynamicPaged<T> = app.models.DynamicResponse<app.models.PagedResult<T>>;

@Injectable()
export class AssetAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'asset';

  public getOrderedAssets(filter: app.models.GetPagedAssetsPageFilterModel) {
    let data = {
      ...filter,
    };
    const request = 'getOrderedAssets';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.postGet<app.models.AssetListModel[]>(url, data);
  }

  public getAssets(pageIndex: number, pageFilter: app.models.GetPagedAssetsPageFilterModel) {
    let data = {
      ...pageFilter,
      page: pageIndex,
      pageSize: DEFAULT_PAGE_SIZE,
    };
    const request = 'getAssets';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.postGet<DynamicPaged<app.models.DriverAssetListModel>>(url, data);
  }

  public getAssetDetails(id: string) {
    const request = 'getAssetDetails';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      assetId: id,
    });
    return this._apiService.get<app.models.AssetDetailModel>(url);
  }

  public updateAssetDeliveryDelegate(assetDeliveryId: string, delegateId: string) {
    const request = 'updateDeliveryDelegate';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.postAsync<app.models.ServerResponseModel>(
      url,
      { assetDeliveryId: assetDeliveryId, delegateId },
      [AssetEvents.AssetDeliveryDelegateChanged]
    );
  }

  public getTimeSlots(scheduleDate: Date) {
    const request = 'getServiceTimeSlots';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, null);
    return this._apiService.postGet<ServiceAppointment.ScheduleModel[]>(url, { date: scheduleDate });
  }

  public getAvailableDates() {
    const request = 'getAvailableDates';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, null);
    return this._apiService.get<Date[]>(url);
  }

  public saveServiceAppointment(saveModel: ServiceAppointment.SaveModel) {
    const request = 'saveServiceAppointment';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, saveModel, [
      ServiceAppointmentEvents.ServicAppointmentSaved,
    ]);
  }

  public getServiceAppointments(contractItemExternalEntityId: string) {
    const request = 'getServiceAppointments';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      contractItemExternalEntityId: contractItemExternalEntityId,
    });
    return this._apiService.get<app.models.HistoryServiceModel[]>(url);
  }
}
